<script lang="ts">
    import CN from "classnames";

    import VideoPlayerUIFullscreenButton from "./VideoPlayerUIFullscreenButton.svelte";
    import VideoPlayerUIPlayButton from "./VideoPlayerUIPlayButton.svelte";
    import VideoPlayerUIProgressSlider from "./VideoPlayerUIProgressSlider.svelte";
    import VideoPlayerUITime from "./VideoPlayerUITime.svelte";
    import VideoPlayerUIVolumeControl from "./VideoPlayerUIVolumeControl.svelte";

    export let hideUiPanel: boolean;
</script>

<div
    class={CN("gw-video-player-panel", {
        "gw-video-player-panel--hide": hideUiPanel,
    })}
>
    <div class="gw-video-player-panel__top">
        <VideoPlayerUIProgressSlider />
    </div>
    <div class="gw-video-player-panel__bottom">
        <div class="gw-video-player-panel__bottom_left">
            <VideoPlayerUIPlayButton />
            <VideoPlayerUIVolumeControl />
        </div>
        <div class="gw-video-player-panel__bottom_right">
            <VideoPlayerUITime />
            <VideoPlayerUIFullscreenButton />
        </div>
    </div>
</div>

<style>
    .gw-video-player-panel {
        display: flex;
        position: absolute;
        z-index: 1;
        right: 0;
        bottom: 0;
        left: 0;
        box-sizing: border-box;
        flex-direction: column;
        width: 100%;
        padding: 0.5rem;
        background: linear-gradient(
            0deg,
            rgba(6, 4, 42, 0.54) 0%,
            rgba(255, 255, 255, 0) 100%
        );
    }

    .gw-video-player-panel--hide {
        transition: opacity 0.2s ease-in-out;
        opacity: 0;
        pointer-events: none;
    }

    .gw-video-player-panel__top {
        display: flex;
        box-sizing: border-box;
        align-items: center;
        justify-content: space-between;
    }
    .gw-video-player-panel__bottom {
        display: flex;
        box-sizing: border-box;
        align-items: center;
        justify-content: space-between;
        column-gap: 5px;
    }
    .gw-video-player-panel__bottom_left {
        display: flex;
        box-sizing: border-box;
        align-items: center;
        justify-content: space-between;
    }
    .gw-video-player-panel__bottom_right {
        display: flex;
        box-sizing: border-box;
        align-items: center;
        justify-content: space-between;
    }
</style>
